/*
 * Copyright 1999-2024 Jagex Ltd.
 */
import styled from '@emotion/styled';
import { layout, LayoutProps } from 'styled-system';
import { Box as BaseBox, BoxProps as BaseBoxProps } from 'theme-ui';

export type BoxProps = BaseBoxProps & LayoutProps;

export const Box = styled(BaseBox)<BoxProps>`
  ${layout}
`;
